module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-subsidies-search-fill-2046414de5669210a2359e1dc1081785.svg";